/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useEffect, useState } from 'react';
import { UserMin } from '../../../constants/users';
import { useAppSelector } from '../../../reducers';
import Loader from '../../loader';
import { MessageFormField, MessageFormProps } from '../types';
import { ContributorVerifierMessageForm } from './ContributorVerifierMessageForm';
import G17Client from '../../../services/G17Client';

interface SurveyMessageFormProps extends MessageFormProps {
  surveyId?: string;
}
export const SurveyMessageForm = (props: SurveyMessageFormProps) => {
  const { surveyId, onChange } = props;

  const [contributorsState, setContributors] = useState<{ users: UserMin[], loaded: boolean }>({ users: [], loaded: false });
  const [verifiersState, setVerifiers] = useState<{ users: UserMin[], loaded: boolean }>({ users: [], loaded: false });

  const initiativeId = useAppSelector(state => state.initiative.loaded ? state.initiative.data._id : undefined);

  useEffect(() => {
    if (!surveyId || !initiativeId || contributorsState.loaded || verifiersState.loaded) {
      return;
    }
    G17Client.getStakeholdersStats({
      initiativeId,
      surveyIds: [surveyId],
    }).then((data) => {
      const verifiers = data.filter(user => user.isVerifier);
      setVerifiers({ users: verifiers, loaded: true });
      onChange(MessageFormField.VerifierIds)(verifiers.map(u => u._id)); // Add all by default

      const contributors = data.filter(user => user.isContributor);
      setContributors({ users: contributors, loaded: true });
      onChange(MessageFormField.ContributorIds)(contributors.map(u => u._id)); // Add all by default
    })
  }, [surveyId, initiativeId, onChange, contributorsState.loaded, verifiersState.loaded]);

  if (!contributorsState.loaded || !verifiersState.loaded) {
    return <Loader />;
  }

  return (
    <>
      <ContributorVerifierMessageForm
        {...props}
        contributors={contributorsState.users}
        verifiers={verifiersState.users}
      />
    </>
  );
}
